import AuthenticationService from 'services/AuthenticationService';
import { BUSINESS } from '../query-keys';
import { useQuery } from '@tanstack/react-query';

export const useBusinessHolidaysCountriesQuery = () => {
  return useQuery({
    queryKey: BUSINESS.HOLIDAYS_COUNTRIES,
    queryFn: AuthenticationService.getBusinessHolidaysCountries,
  });
};

export const useBusinessTextNumberQuery = (enabled = false) => {
  return useQuery({
    queryKey: BUSINESS.TEXT_NUMBER,
    queryFn: AuthenticationService.getBusinessTextNumber,
    enabled,
  });
};
